import { useContext } from "react";
import State from "../../../../../../../../context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Flex, Row, Dropdown, theme } from "antd";
import CardPortfolio from "../../../CardPortfolio";
import ChartGaugeLevel from "../../../ChartGaugeLevel";
import ChartIncomeWithTypesLevel from "../../../ChartIncomeWithTypesLevel";
import ChartProjection from "../../../ChartProjection";
import ChartToggle from "./component/ChartToggle";
import FormMc from "./component/FormMc";
import FormStressTest from "./component/FormStressTest";
import InvestmentAssumptions from "./component/InvestmentAssumptions";
import SectionCompare from "../SectionCompare";

import StyledContainer from "./style";

import {
  CHART_VIEW_OBJECTIVE_GROWTH,
  CHART_VIEW_OBJECTIVE_INCOME,
} from "../../../../constant";

import { ReactComponent as MainMenu } from "../../image/icon_main_menu.svg";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const SectionGoalDetails = ({
  accentHeroSection,
  activeStressTestData,
  activeView,
  chartLoading,
  handleButtonProductOptions,
  handleCardClick,
  handleCloseCompareMode,
  handleCloseMonteCarlo,
  handleCloseStressTesting,
  handleInvestmentAssumptionsChange,
  handleShowCompareMode,
  handleShowMonteCarlo,
  handleShowStressTest,
  mcData,
  productsLiveAssessment,
  productsLiveSimulation,
  proposalData,
  setActiveStressTestData,
  setActiveView,
  setChartLoading,
  stressorChance,
  stressorProjection,
}) => {
  const [state] = useContext(State);
  const { token } = theme.useToken();

  const selectedProductData = state.productsList?.find(
    it => it._id === state.selectedProduct
  );

  return (
    <StyledContainer className={accentHeroSection && "accent-hero-section"}>
      <Row style={{ gap: 77 }} wrap={false}>
        <Col flex="213px">
          <InvestmentAssumptions
            handleProposalDataChange={handleInvestmentAssumptionsChange}
            loading={state.loading || chartLoading}
            managerAccess={state.managerAccess}
            openAdvancedSettings={() =>
              state.setKeyValue("openModalAdvancedSettings", true)
            }
            organization={state.organization?.name}
            proposalData={proposalData}
          />
        </Col>

        <Col
          className={`container-hero-section ${
            state.showMonteCarlo ||
            state.showStressTesting ||
            state.showCompareMode
              ? "active"
              : ""
          }`}
          flex="auto"
        >
          <section>
            {state.showCompareMode && (
              <header>
                <Flex align="center" justify="space-between">
                  <h5>Compare Mode</h5>
                  <Button onClick={handleCloseCompareMode} shape="round">
                    Close Compare Mode <FontAwesomeIcon icon={faClose} />
                  </Button>
                </Flex>
              </header>
            )}

            {state.showMonteCarlo && (
              <header>
                <Flex align="center" justify="space-between">
                  <h5>Monte Carlo</h5>
                  <Button onClick={handleCloseMonteCarlo} shape="round">
                    Close Monte Carlo <FontAwesomeIcon icon={faClose} />
                  </Button>
                </Flex>
              </header>
            )}

            {state.showStressTesting && (
              <header>
                <Flex align="center" justify="space-between">
                  <h5>Stress Testing</h5>
                  <Button onClick={handleCloseStressTesting} shape="round">
                    Close Stress Testing <FontAwesomeIcon icon={faClose} />
                  </Button>
                </Flex>
              </header>
            )}

            <Row className="container-chart" wrap={false}>
              <Col flex="auto">
                <Row
                  gutter={[22, 22]}
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Col span={24}>
                    <Flex justify="space-between">
                      {!state.showMonteCarlo && (
                        <ChartToggle
                          activeView={activeView}
                          setActiveView={setActiveView}
                          views={
                            proposalData?.investmentObjective === "growth"
                              ? CHART_VIEW_OBJECTIVE_GROWTH
                              : CHART_VIEW_OBJECTIVE_INCOME
                          }
                        />
                      )}

                      <Dropdown
                        className="menu-view-mode"
                        disabled={chartLoading}
                        menu={{
                          items: [
                            {
                              key: "stressTesting",
                              label: "Stress Testing",
                              onClick: handleShowStressTest,
                            },
                            {
                              key: "compareMode",
                              label: "Compare Mode",
                              onClick: handleShowCompareMode,
                            },
                            {
                              key: "monteCarlo",
                              label: "Monte Carlo",
                              onClick: handleShowMonteCarlo,
                            },
                          ],
                        }}
                        trigger={["click"]}
                      >
                        <Button icon={<MainMenu />} shape="round" />
                      </Dropdown>
                    </Flex>

                    {activeView === "projection" ? (
                      <ChartProjection
                        activeStressTestData={activeStressTestData}
                        isStressorMode={state.showStressTesting}
                        loading={chartLoading}
                        mcData={mcData}
                        productsList={state.productsList}
                        proposalData={proposalData}
                        productsLiveAssessment={productsLiveAssessment}
                        setActiveStressTestData={setActiveStressTestData}
                        stressorProjection={stressorProjection}
                        viewMode={state.viewMode}
                      />
                    ) : (
                      <ChartIncomeWithTypesLevel
                        activeStressTestData={activeStressTestData}
                        chartType={activeView}
                        height={300}
                        hideChartTypeButtons
                        isCompareMode={state.showCompareMode}
                        isStressorMode={state.showStressTesting}
                        loading={chartLoading}
                        setLoading={setChartLoading}
                        productsList={state.productsList}
                        productsLiveAssessment={productsLiveAssessment}
                        productData={proposalData}
                        stressorProjection={stressorProjection}
                        viewMode={state.viewMode}
                      />
                    )}
                  </Col>
                </Row>
              </Col>
              <Col flex="146px" style={{ height: "fit-content" }}>
                <ChartGaugeLevel
                  investmentObjective={proposalData?.investmentObjective}
                  loading={chartLoading}
                  productsLiveSimulation={productsLiveSimulation}
                  stressorCalculations={activeStressTestData && stressorChance}
                />
              </Col>
            </Row>
          </section>

          <footer>
            <Flex align="center" className="header" justify="space-between">
              <h4>How will this portfolio impact my scenario?</h4>
              <Button
                onClick={() =>
                  state.setKeyValue("openModalRelatedProducts", true)
                }
                shape="round"
              >
                Other Investments
              </Button>
            </Flex>

            <Flex>
              <Flex className="container-selected-investment" vertical>
                <h5 className="card-portfolio-title">Selected Investment</h5>

                <CardPortfolio
                  chartLineColor={token.comparison_products_colors[0]}
                  chartLineShow={state.showCompareMode}
                  handleButtonDetails={() =>
                    handleCardClick(selectedProductData?._id)
                  }
                  handleButtonOptions={() =>
                    handleButtonProductOptions(selectedProductData?._id)
                  }
                  loading={state.loading || chartLoading}
                  riskScore={
                    selectedProductData?.properties?.mcVolatilityReturn ??
                    selectedProductData?.RiskScore ??
                    Math.round(selectedProductData?.RiskNumber * 1000) / 10
                  }
                  riskTolerance={
                    selectedProductData?.riskTolerance ??
                    selectedProductData?.RiskType
                  }
                  title={selectedProductData?.name ?? selectedProductData?.Name}
                />
              </Flex>

              {state.showStressTesting && (
                <FormStressTest onStressTestChange={setActiveStressTestData} />
              )}

              {state.showMonteCarlo && <FormMc />}

              {state.showCompareMode && (
                <SectionCompare
                  compareProducts={state.compareProducts}
                  handleButtonProductOptions={handleButtonProductOptions}
                  handleCardClick={handleCardClick}
                  loading={state.loading || chartLoading}
                  openProductsListModal={() =>
                    state.setKeyValue("openModalRelatedProducts", true)
                  }
                  productsList={state.productsList}
                  selectedProductId={selectedProductData?._id}
                />
              )}
            </Flex>
          </footer>
        </Col>
      </Row>
    </StyledContainer>
  );
};

export default SectionGoalDetails;
